import { Draggable } from 'react-beautiful-dnd';
import MenuInput from './MenuInput';
import IconButton from '@mui/material/IconButton';
import DragIcon from '@mui/icons-material/DragHandle';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import getItemStyle from '../styles/getItemStyle';
import sty from '../styles/SubTabs.module.css';
import { Tab } from '../const';
import { func, number, object } from 'prop-types';

/**
 * @component SubTab
 * @param { Object } props
 * @param { number } props.index
 * @param { object } props.tab
 * @param { function } props.onCheck
 * @param { function } props.onHandle
 * @returns { JSX.Element }
 */
function SubTab({ index, tab, onCheck, onHandle }) {
	return (
		<Draggable key={tab[Tab.Id]} index={index} draggableId={tab[Tab.Id]}>
			{(provided, snapshot) => (
				<section
					ref={provided.innerRef}
					{...provided.draggableProps}
					className={sty.subtab_section}
					style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
				>
					<div className={sty.subtab_subtab}>
						<IconButton {...provided.dragHandleProps}>
							<DragIcon />
						</IconButton>
						<Checkbox checked={tab[Tab.Checked]} onClick={() => onCheck(tab[Tab.Id])} />
						<MenuInput id={tab[Tab.Id]} name="tabName" value={tab[Tab.Name]} onHandle={onHandle} />
						<MenuInput id={tab[Tab.Id]} name="tabUrl" value={tab[Tab.Url]} onHandle={onHandle} />
						<MenuInput id={tab[Tab.Id]} name="tabDesc" value={tab[Tab.Desc]} onHandle={onHandle} />
					</div>
					<Divider className={sty.divider} />
				</section>
			)}
		</Draggable>
	);
}

SubTab.propTypes = {
	index: number,
	tab: object,
	onCheck: func,
	onHandle: func,
};

export default SubTab;
